<template>
  <div class="child">
    <div>
      <div class="main">
        <div class="list">
          <div>数据中心</div>
          <ul>
            <li v-for="item in tabs" :key="item.index">
              <router-link active-class="active" :to="{name:item.path}">{{item.type}}</router-link>
            </li>
          </ul>
        </div>
        <div class="con">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataCenter',
  data () {
    return {
      tabs: [
        {
          type: '抽样方案',
          path: 'sampling'
        }, {
          type: '调查实施',
          path: 'process'
        }/* , {
          type: '调查负责人工作流程示意图',
          path: 'diagram'
        } */, {
          type: '部分数据开放',
          path: 'partialData'
        }, {
          type: '数据申请',
          path: 'dataApply'
        }
      ]
    }
  },
}
</script>
<style scoped src="../assets/style/child.css">
  /* @import '../assets/style/child.css'; */
</style>


// WEBPACK FOOTER //
// src/components/DataCenter.vue